export const ERROR_MESSAGE = {
  INVALID_USER_TYPE: 'このユーザはご利用いただけません。',
  TOKEN_EXPIRED: '認証の有効期限が切れました。再ログインしてください。',
};
